import React from 'react'
import {
    AccountCircle,
    Hotel,
    PercentDiscount,
    Travel,
    VisaIcon
} from '@/src/ct-design/assets/svg'
import { Container } from '@/src/ct-design/lib'
import { Brand } from '@/src/utils/brand'

const BottomNavbar_HOME_VAL = 'home'
const BottomNavbar_HOTELS_VAL = 'hotels'
const BottomNavbar_VISA_VAL = 'visa'
const BottomNavbar_OFFER_VAL = 'offer'
const BottomNavbar_ACC_VAL = 'myAccount'

const TOOLBAR_LINKS = [
    { label: 'Flights', value: BottomNavbar_HOME_VAL },
    { label: 'Hotels', value: BottomNavbar_HOTELS_VAL },
    { label: 'Visa', value: BottomNavbar_VISA_VAL },
    { label: 'Offers', value: BottomNavbar_OFFER_VAL },
    { label: 'Account', value: BottomNavbar_ACC_VAL }
]

interface BottomNavbarProps {
    brand: Brand
    selected?: number
    onSelectItem?: (index: number, value: string) => void
}

const BottomNavbar: React.FC<BottomNavbarProps> = (props) => {
    const { selected = 0, onSelectItem } = props
    const navItemsList = TOOLBAR_LINKS
    const selectedIndex = selected

    const getIcon = (icon: string) => {
        switch (icon) {
            case 'hotels':
                return <Hotel />
            case 'offer':
                return <PercentDiscount />
            case 'visa':
                return <VisaIcon />
            case 'myAccount':
                return <AccountCircle />
            case 'home':
            default:
                return <Travel />
        }
    }

    return (
        <Container
            className='flex p-fixed b-0 l-0 r-0 w-100p z-50'
            backgroundColor='#FFFFFF'
            style={{
                height: 'auto',
                minHeight: '56px',
                padding: '12px 16px',
            }}
        >
            <Container className='flex flex-row w-100p flex-between'>
                {navItemsList.map((item, index) => (
                    <Container
                        key={index}
                        className='flex flex-column flex-center flex-1 c-pointer p-2'
                        style={{
                            width: '60px',
                            minWidth: '60px',
                            height: '41px',
                            gap: '4px',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        onClick={() =>
                            onSelectItem && onSelectItem(index, item.value)
                        }
                    >
                        <Container
                            className='flex flex-center'
                            style={{
                                width: '24px',
                                height: '24px',
                                color:
                                    selectedIndex === index
                                        ? '#2A5298'
                                        : '#00000099'
                            }}
                        >
                            {getIcon(item.value)}
                        </Container>
                        <Container
                            className='ta-c'
                            style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    color:
                                        selectedIndex === index
                                            ? '#2A5298'
                                            : '#00000099'
                                }}
                            >
                                {item.label}
                            </span>
                        </Container>
                    </Container>
                ))}
            </Container>
        </Container>
    )
}

export default BottomNavbar
